import Vue from 'vue'
import FoalRegistration from 'FrontComponents/vue/Account/FoalRegistration.vue'
import HorseCard from 'FrontComponents/vue/Account/HorseCard.vue'
import Lang from '~/lang'


/**
 * Then you can do stuff like this:
 *
 * {{ 'javascript.title.home' | trans }}
 * {{ 'javascript.title.welcome' | trans({ name: 'Nasirou' }) }}
 */
Vue.filter('trans', (...args) => {
    return Lang.get(...args)
})

Vue.filter('lowercase', (value) => {
    return value.toString().toLowerCase()
})
Vue.filter('snakecase', (value) => {
    const str = value.toString()

    return str.replace(/[\w\s]+/g, function (match) {
        return match.trim().toLowerCase().replace(/\s+/g, '_');
    });
})

/**
 * Then you can do stuff like this:
 *
 * route('')
 */

if (document.querySelector('#foal-registration')) {

    Vue.config.productionTip = false
    Vue.config.ignoredElements = ['drop-files']
    new Vue({
        el: '#foal-registration',
        components: {
            FoalRegistration,
            HorseCard
        },
    })
}

